import { z } from "zod";

/**
 * Zod validators for finding metrics enums
 * Related change: finding-metrics-canonical
 */

export const complianceImpactSchema = z.enum([
  "critical",
  "major",
  "minor",
  "informational",
]);

export const taskImpactSchema = z.enum([
  "blocks",
  "impairs",
  "slows",
  "neutral",
  "accelerates",
  "enables",
]);

export const confidenceSchema = z.enum(["high", "medium", "low"]);

export const taskCriticalitySchema = z.enum([
  "critical_path",
  "important",
  "optional",
]);

export const scopeSchema = z.enum([
  "pervasive",
  "common",
  "occasional",
  "edge_case",
]);

export const fixStatusSchema = z.enum([
  "open",
  "fix_proposed",
  "fix_applied",
  "verified_resolved",
  "verified_persists",
  "wont_fix",
]);

export const fixAttemptTypeSchema = z.enum([
  "prototype_iteration",
  "code_pr",
  "manual",
]);

export const verificationOutcomeSchema = z.enum(["resolved", "persists"]);

// Type exports for convenience
export type ComplianceImpact = z.infer<typeof complianceImpactSchema>;
export type TaskImpact = z.infer<typeof taskImpactSchema>;
export type Confidence = z.infer<typeof confidenceSchema>;
export type TaskCriticality = z.infer<typeof taskCriticalitySchema>;
export type Scope = z.infer<typeof scopeSchema>;
export type FixStatus = z.infer<typeof fixStatusSchema>;
export type FixAttemptType = z.infer<typeof fixAttemptTypeSchema>;
export type VerificationOutcome = z.infer<typeof verificationOutcomeSchema>;
